/** @jsxRuntime classic */
/** @jsx jsx */
/** @jsxFrag Fragment */
// @ts-check
import { gql } from '@apollo/client';
import { Col, Container } from '@bottlebooks/gatsby-design-system';
import { graphql } from 'gatsby';
import { Fragment } from 'react';
import { jsx } from 'theme-ui';
import ContentRow from '../ContentRow';
import ExhibitorContacts from '../ExhibitorPage/ExhibitorContacts';
import ProductDetailsSection from './ProductDetailsSection';

/**
 * A component to contain all the product details sections.
 * It can be used to prepend or append some content in shadowed components.
 * @param {object} props
 * @param {object} props.exhibitor The exhibitor.
 * @param {object} props.product The product.
 * @param {object} props.eventId The eventId.
 * @returns
 */
export default function ProductSections({ exhibitor, product, eventId }) {
  return (
    <>
      <Container sx={{ width: '100%' }}>
        <ContentRow>
          <Col flex>
            <ExhibitorContacts
              exhibitor={exhibitor}
              eventId={eventId}
              sx={{ marginBottom: 3 }}
            />
          </Col>
        </ContentRow>
        <ContentRow>
          <ProductDetailsSection product={product} />
        </ContentRow>
      </Container>
      {/* <NoteableBanner product={product} /> */}
    </>
  );
}

export const fragment = graphql`
  fragment ProductSections_RegisteredProduct on Bottlebooks_RegisteredProduct {
    productId
    # ...NoteableBanner
  }
  fragment bb_ProductSections on Bottlebooks_Product {
    ...bb_ProductDetailsSection
  }

  fragment ProductSections on Product {
    ...ProductDetailsSection
  }
`;

ProductSections.fragment = gql`
  fragment ProductSections on RegisteredProduct {
    ...ProductDetailsSection_RegisteredProduct
  }
  ${ProductDetailsSection.fragment}
`;
